import { useState } from "react";
import { useAuth } from "react-oidc-context";

const API_URL = process.env.REACT_APP_API_URL || "/api";

export const useCreateGreenMilesDemos = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const auth = useAuth();

  const createDemo = async (demoData) => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(`${API_URL}/greenmiles/demos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth.user.access_token}`,
        },
        body: JSON.stringify(demoData),
      });

      const data = await response.json();

      if (!response.ok || data.success === "ERROR") {
        throw new Error(data.message || "Erreur lors de la création de la démo");
      }

      setSuccess(true);
      return {
        success: true,
        data: data.result,
        message: data.message,
      };
    } catch (err) {
      console.error("Erreur lors de la création de la démo GreenMiles:", err);
      setError(err.message);
      return {
        success: false,
        error: err.message,
      };
    } finally {
      setIsLoading(false);
    }
  };

  const resetState = () => {
    setError(null);
    setSuccess(false);
    setIsLoading(false);
  };

  return {
    createDemo,
    isLoading,
    error,
    success,
    resetState,
  };
};


